export default __webpack_public_path__ + "static/media/free-trial.c9fdff10.png";